import { injectable } from 'tsyringe';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { OperatorBillingService, type OperatorInvoice } from './OperatorBillingService';

@injectable()
export class OperatorBillingViewModel extends BaseViewModel {
    invoices: OperatorInvoice[] = [];
    loading = false;
    error: string | null = null;

    constructor(private readonly service: OperatorBillingService) {
        super();
    }

    openInvoice(tenantId: string, invoiceId: string): Promise<void> {
        return this.service.openInvoicePdf(tenantId, invoiceId);
    }

    async load(): Promise<void> {
        this.loading = true;
        this.error = null;
        this.notifyChange();
        try {
            this.invoices = await this.service.getInvoices();
        } catch (e) {
            this.error = e instanceof Error ? e.message : 'Failed to load invoices';
        } finally {
            this.loading = false;
            this.notifyChange();
        }
    }
}
